import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface UpdateFeedbackParameters {
  id: string;
  response?: string;
  freeText?: string;
}

export const useUpdateFeedback = () => {
  const { getFetchConfig } = useGetFetchConfig();

  const updateFeedback = useMutation(async ({ id, response, freeText }: UpdateFeedbackParameters) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.PATCH,
      data: { response, freeText },
    });

    const res = await fetch(`${APIBaseChronos}/api/feedback/${id}`, fetchConfig);

    if (!res.ok) {
      throw new Error('Failed to update feedback');
    }

    return res.json();
  });

  return { updateFeedback };
};
